// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","customGrey":"#4b4b4b","lightGrey":"#fcfcfc","caption":"_1dJD2pSCq2-UhXWE_3mRfd","imagesContainer":"y8ap4GrVhK2baywBF_L9e","productImage":"_1Ujl7JIqXwsNfhcyalUsnd","whiteImage":"vtHklxnbbWW_AvFA2oF0d","imageError":"_3qmZSikDuSFaDSuZOhObuQ","svgWhite":"_2MLqeDfqWuBB24s61LGdug","textError":"_2pE8dz4futRorAvf0TsfEy _1dJD2pSCq2-UhXWE_3mRfd"};


//////////////////
// WEBPACK FOOTER
// ./src/common/product-image/ProductImage.css
// module id = 400
// module chunks = 0 1 2